import { Standard } from '@getvim/vim-connect';

export const providerDemographics: Standard.Entities.ProviderDemographics = {
  firstName: '',
  lastName: '',
  middleName: '',
};
